// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/common.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "api.devplan.types.common";

export interface IconInfo {
  path?: string | undefined;
  lucideIcon?: LucideIcon | undefined;
}

export interface LucideIcon {
  name: string;
  color: string;
}

export interface InfoSectionDefinition {
  name: string;
  title: string;
  description: string;
  type:
    | { $case: "text"; value: TextSectionDefinition }
    | { $case: "choice"; value: ChoiceSectionDefinition }
    | undefined;
}

export interface TextSectionDefinition {
}

export interface ChoiceSectionDefinition {
  choices: string[];
  multi: boolean;
}

export interface InfoSection {
  name: string;
  type: { $case: "text"; value: TextSectionValue } | { $case: "choice"; value: ChoiceSectionValue } | undefined;
}

export interface TextSectionValue {
  text: string;
}

export interface ChoiceSectionValue {
  choices: string[];
}

export interface EntityMeta {
  createdBy: string;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
}

export interface TokensUsage {
  meta: TokensUsageMeta | undefined;
  stats: TokensUsageStats | undefined;
}

export interface TokensUsageMeta {
  provider: string;
  model: string;
}

export interface TokensUsageStats {
  inputTokens: number;
  outputTokens: number;
  totalTokens: number;
  inputTokenDetails: InputTokenDetails | undefined;
  outputTokenDetails: OutputTokenDetails | undefined;
}

export interface InputTokenDetails {
  audio: number;
  cacheRead: number;
  cacheCreation: number;
}

export interface OutputTokenDetails {
  audio: number;
  reasoning: number;
}

export interface UserMention {
  userId: string;
  companyId: number;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  target: { $case: "commentId"; value: string } | { $case: "documentId"; value: string } | undefined;
}

export interface ChunksInfo {
  totalChunks: number;
}

export interface ErrorInfo {
  message: string;
  ts: Date | undefined;
}

function createBaseIconInfo(): IconInfo {
  return { path: undefined, lucideIcon: undefined };
}

export const IconInfo: MessageFns<IconInfo> = {
  encode(message: IconInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== undefined) {
      writer.uint32(10).string(message.path);
    }
    if (message.lucideIcon !== undefined) {
      LucideIcon.encode(message.lucideIcon, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IconInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIconInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.lucideIcon = LucideIcon.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IconInfo {
    return {
      path: isSet(object.path) ? globalThis.String(object.path) : undefined,
      lucideIcon: isSet(object.lucideIcon)
        ? LucideIcon.fromJSON(object.lucideIcon)
        : isSet(object.lucide_icon)
        ? LucideIcon.fromJSON(object.lucide_icon)
        : undefined,
    };
  },

  toJSON(message: IconInfo): unknown {
    const obj: any = {};
    if (message.path !== undefined) {
      obj.path = message.path;
    }
    if (message.lucideIcon !== undefined) {
      obj.lucideIcon = LucideIcon.toJSON(message.lucideIcon);
    }
    return obj;
  },

  create(base?: DeepPartial<IconInfo>): IconInfo {
    return IconInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IconInfo>): IconInfo {
    const message = createBaseIconInfo();
    message.path = object.path ?? undefined;
    message.lucideIcon = (object.lucideIcon !== undefined && object.lucideIcon !== null)
      ? LucideIcon.fromPartial(object.lucideIcon)
      : undefined;
    return message;
  },
};

function createBaseLucideIcon(): LucideIcon {
  return { name: "", color: "" };
}

export const LucideIcon: MessageFns<LucideIcon> = {
  encode(message: LucideIcon, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.color !== "") {
      writer.uint32(18).string(message.color);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LucideIcon {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLucideIcon();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.color = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LucideIcon {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      color: isSet(object.color) ? globalThis.String(object.color) : "",
    };
  },

  toJSON(message: LucideIcon): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.color !== "") {
      obj.color = message.color;
    }
    return obj;
  },

  create(base?: DeepPartial<LucideIcon>): LucideIcon {
    return LucideIcon.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LucideIcon>): LucideIcon {
    const message = createBaseLucideIcon();
    message.name = object.name ?? "";
    message.color = object.color ?? "";
    return message;
  },
};

function createBaseInfoSectionDefinition(): InfoSectionDefinition {
  return { name: "", title: "", description: "", type: undefined };
}

export const InfoSectionDefinition: MessageFns<InfoSectionDefinition> = {
  encode(message: InfoSectionDefinition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    switch (message.type?.$case) {
      case "text":
        TextSectionDefinition.encode(message.type.value, writer.uint32(802).fork()).join();
        break;
      case "choice":
        ChoiceSectionDefinition.encode(message.type.value, writer.uint32(810).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InfoSectionDefinition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInfoSectionDefinition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.type = { $case: "text", value: TextSectionDefinition.decode(reader, reader.uint32()) };
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.type = { $case: "choice", value: ChoiceSectionDefinition.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InfoSectionDefinition {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      type: isSet(object.text)
        ? { $case: "text", value: TextSectionDefinition.fromJSON(object.text) }
        : isSet(object.choice)
        ? { $case: "choice", value: ChoiceSectionDefinition.fromJSON(object.choice) }
        : undefined,
    };
  },

  toJSON(message: InfoSectionDefinition): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.type?.$case === "text") {
      obj.text = TextSectionDefinition.toJSON(message.type.value);
    } else if (message.type?.$case === "choice") {
      obj.choice = ChoiceSectionDefinition.toJSON(message.type.value);
    }
    return obj;
  },

  create(base?: DeepPartial<InfoSectionDefinition>): InfoSectionDefinition {
    return InfoSectionDefinition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<InfoSectionDefinition>): InfoSectionDefinition {
    const message = createBaseInfoSectionDefinition();
    message.name = object.name ?? "";
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    switch (object.type?.$case) {
      case "text": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "text", value: TextSectionDefinition.fromPartial(object.type.value) };
        }
        break;
      }
      case "choice": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "choice", value: ChoiceSectionDefinition.fromPartial(object.type.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseTextSectionDefinition(): TextSectionDefinition {
  return {};
}

export const TextSectionDefinition: MessageFns<TextSectionDefinition> = {
  encode(_: TextSectionDefinition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TextSectionDefinition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTextSectionDefinition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TextSectionDefinition {
    return {};
  },

  toJSON(_: TextSectionDefinition): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<TextSectionDefinition>): TextSectionDefinition {
    return TextSectionDefinition.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<TextSectionDefinition>): TextSectionDefinition {
    const message = createBaseTextSectionDefinition();
    return message;
  },
};

function createBaseChoiceSectionDefinition(): ChoiceSectionDefinition {
  return { choices: [], multi: false };
}

export const ChoiceSectionDefinition: MessageFns<ChoiceSectionDefinition> = {
  encode(message: ChoiceSectionDefinition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.choices) {
      writer.uint32(10).string(v!);
    }
    if (message.multi !== false) {
      writer.uint32(16).bool(message.multi);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChoiceSectionDefinition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChoiceSectionDefinition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.choices.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.multi = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChoiceSectionDefinition {
    return {
      choices: globalThis.Array.isArray(object?.choices) ? object.choices.map((e: any) => globalThis.String(e)) : [],
      multi: isSet(object.multi) ? globalThis.Boolean(object.multi) : false,
    };
  },

  toJSON(message: ChoiceSectionDefinition): unknown {
    const obj: any = {};
    if (message.choices?.length) {
      obj.choices = message.choices;
    }
    if (message.multi !== false) {
      obj.multi = message.multi;
    }
    return obj;
  },

  create(base?: DeepPartial<ChoiceSectionDefinition>): ChoiceSectionDefinition {
    return ChoiceSectionDefinition.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ChoiceSectionDefinition>): ChoiceSectionDefinition {
    const message = createBaseChoiceSectionDefinition();
    message.choices = object.choices?.map((e) => e) || [];
    message.multi = object.multi ?? false;
    return message;
  },
};

function createBaseInfoSection(): InfoSection {
  return { name: "", type: undefined };
}

export const InfoSection: MessageFns<InfoSection> = {
  encode(message: InfoSection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    switch (message.type?.$case) {
      case "text":
        TextSectionValue.encode(message.type.value, writer.uint32(802).fork()).join();
        break;
      case "choice":
        ChoiceSectionValue.encode(message.type.value, writer.uint32(810).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InfoSection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInfoSection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.type = { $case: "text", value: TextSectionValue.decode(reader, reader.uint32()) };
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.type = { $case: "choice", value: ChoiceSectionValue.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InfoSection {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      type: isSet(object.text)
        ? { $case: "text", value: TextSectionValue.fromJSON(object.text) }
        : isSet(object.choice)
        ? { $case: "choice", value: ChoiceSectionValue.fromJSON(object.choice) }
        : undefined,
    };
  },

  toJSON(message: InfoSection): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.type?.$case === "text") {
      obj.text = TextSectionValue.toJSON(message.type.value);
    } else if (message.type?.$case === "choice") {
      obj.choice = ChoiceSectionValue.toJSON(message.type.value);
    }
    return obj;
  },

  create(base?: DeepPartial<InfoSection>): InfoSection {
    return InfoSection.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<InfoSection>): InfoSection {
    const message = createBaseInfoSection();
    message.name = object.name ?? "";
    switch (object.type?.$case) {
      case "text": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "text", value: TextSectionValue.fromPartial(object.type.value) };
        }
        break;
      }
      case "choice": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "choice", value: ChoiceSectionValue.fromPartial(object.type.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseTextSectionValue(): TextSectionValue {
  return { text: "" };
}

export const TextSectionValue: MessageFns<TextSectionValue> = {
  encode(message: TextSectionValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.text !== "") {
      writer.uint32(10).string(message.text);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TextSectionValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTextSectionValue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.text = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TextSectionValue {
    return { text: isSet(object.text) ? globalThis.String(object.text) : "" };
  },

  toJSON(message: TextSectionValue): unknown {
    const obj: any = {};
    if (message.text !== "") {
      obj.text = message.text;
    }
    return obj;
  },

  create(base?: DeepPartial<TextSectionValue>): TextSectionValue {
    return TextSectionValue.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TextSectionValue>): TextSectionValue {
    const message = createBaseTextSectionValue();
    message.text = object.text ?? "";
    return message;
  },
};

function createBaseChoiceSectionValue(): ChoiceSectionValue {
  return { choices: [] };
}

export const ChoiceSectionValue: MessageFns<ChoiceSectionValue> = {
  encode(message: ChoiceSectionValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.choices) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChoiceSectionValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChoiceSectionValue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.choices.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChoiceSectionValue {
    return {
      choices: globalThis.Array.isArray(object?.choices) ? object.choices.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: ChoiceSectionValue): unknown {
    const obj: any = {};
    if (message.choices?.length) {
      obj.choices = message.choices;
    }
    return obj;
  },

  create(base?: DeepPartial<ChoiceSectionValue>): ChoiceSectionValue {
    return ChoiceSectionValue.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ChoiceSectionValue>): ChoiceSectionValue {
    const message = createBaseChoiceSectionValue();
    message.choices = object.choices?.map((e) => e) || [];
    return message;
  },
};

function createBaseEntityMeta(): EntityMeta {
  return { createdBy: "", createdAt: undefined, updatedAt: undefined };
}

export const EntityMeta: MessageFns<EntityMeta> = {
  encode(message: EntityMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.createdBy !== "") {
      writer.uint32(10).string(message.createdBy);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(18).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntityMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntityMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntityMeta {
    return {
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: EntityMeta): unknown {
    const obj: any = {};
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<EntityMeta>): EntityMeta {
    return EntityMeta.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EntityMeta>): EntityMeta {
    const message = createBaseEntityMeta();
    message.createdBy = object.createdBy ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseTokensUsage(): TokensUsage {
  return { meta: undefined, stats: undefined };
}

export const TokensUsage: MessageFns<TokensUsage> = {
  encode(message: TokensUsage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.meta !== undefined) {
      TokensUsageMeta.encode(message.meta, writer.uint32(10).fork()).join();
    }
    if (message.stats !== undefined) {
      TokensUsageStats.encode(message.stats, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TokensUsage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTokensUsage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.meta = TokensUsageMeta.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stats = TokensUsageStats.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TokensUsage {
    return {
      meta: isSet(object.meta) ? TokensUsageMeta.fromJSON(object.meta) : undefined,
      stats: isSet(object.stats) ? TokensUsageStats.fromJSON(object.stats) : undefined,
    };
  },

  toJSON(message: TokensUsage): unknown {
    const obj: any = {};
    if (message.meta !== undefined) {
      obj.meta = TokensUsageMeta.toJSON(message.meta);
    }
    if (message.stats !== undefined) {
      obj.stats = TokensUsageStats.toJSON(message.stats);
    }
    return obj;
  },

  create(base?: DeepPartial<TokensUsage>): TokensUsage {
    return TokensUsage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TokensUsage>): TokensUsage {
    const message = createBaseTokensUsage();
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? TokensUsageMeta.fromPartial(object.meta)
      : undefined;
    message.stats = (object.stats !== undefined && object.stats !== null)
      ? TokensUsageStats.fromPartial(object.stats)
      : undefined;
    return message;
  },
};

function createBaseTokensUsageMeta(): TokensUsageMeta {
  return { provider: "", model: "" };
}

export const TokensUsageMeta: MessageFns<TokensUsageMeta> = {
  encode(message: TokensUsageMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== "") {
      writer.uint32(10).string(message.provider);
    }
    if (message.model !== "") {
      writer.uint32(18).string(message.model);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TokensUsageMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTokensUsageMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.model = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TokensUsageMeta {
    return {
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      model: isSet(object.model) ? globalThis.String(object.model) : "",
    };
  },

  toJSON(message: TokensUsageMeta): unknown {
    const obj: any = {};
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.model !== "") {
      obj.model = message.model;
    }
    return obj;
  },

  create(base?: DeepPartial<TokensUsageMeta>): TokensUsageMeta {
    return TokensUsageMeta.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TokensUsageMeta>): TokensUsageMeta {
    const message = createBaseTokensUsageMeta();
    message.provider = object.provider ?? "";
    message.model = object.model ?? "";
    return message;
  },
};

function createBaseTokensUsageStats(): TokensUsageStats {
  return {
    inputTokens: 0,
    outputTokens: 0,
    totalTokens: 0,
    inputTokenDetails: undefined,
    outputTokenDetails: undefined,
  };
}

export const TokensUsageStats: MessageFns<TokensUsageStats> = {
  encode(message: TokensUsageStats, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.inputTokens !== 0) {
      writer.uint32(8).int32(message.inputTokens);
    }
    if (message.outputTokens !== 0) {
      writer.uint32(16).int32(message.outputTokens);
    }
    if (message.totalTokens !== 0) {
      writer.uint32(24).int32(message.totalTokens);
    }
    if (message.inputTokenDetails !== undefined) {
      InputTokenDetails.encode(message.inputTokenDetails, writer.uint32(34).fork()).join();
    }
    if (message.outputTokenDetails !== undefined) {
      OutputTokenDetails.encode(message.outputTokenDetails, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TokensUsageStats {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTokensUsageStats();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.inputTokens = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.outputTokens = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.totalTokens = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.inputTokenDetails = InputTokenDetails.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.outputTokenDetails = OutputTokenDetails.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TokensUsageStats {
    return {
      inputTokens: isSet(object.inputTokens)
        ? globalThis.Number(object.inputTokens)
        : isSet(object.input_tokens)
        ? globalThis.Number(object.input_tokens)
        : 0,
      outputTokens: isSet(object.outputTokens)
        ? globalThis.Number(object.outputTokens)
        : isSet(object.output_tokens)
        ? globalThis.Number(object.output_tokens)
        : 0,
      totalTokens: isSet(object.totalTokens)
        ? globalThis.Number(object.totalTokens)
        : isSet(object.total_tokens)
        ? globalThis.Number(object.total_tokens)
        : 0,
      inputTokenDetails: isSet(object.inputTokenDetails)
        ? InputTokenDetails.fromJSON(object.inputTokenDetails)
        : isSet(object.input_token_details)
        ? InputTokenDetails.fromJSON(object.input_token_details)
        : undefined,
      outputTokenDetails: isSet(object.outputTokenDetails)
        ? OutputTokenDetails.fromJSON(object.outputTokenDetails)
        : isSet(object.output_token_details)
        ? OutputTokenDetails.fromJSON(object.output_token_details)
        : undefined,
    };
  },

  toJSON(message: TokensUsageStats): unknown {
    const obj: any = {};
    if (message.inputTokens !== 0) {
      obj.inputTokens = Math.round(message.inputTokens);
    }
    if (message.outputTokens !== 0) {
      obj.outputTokens = Math.round(message.outputTokens);
    }
    if (message.totalTokens !== 0) {
      obj.totalTokens = Math.round(message.totalTokens);
    }
    if (message.inputTokenDetails !== undefined) {
      obj.inputTokenDetails = InputTokenDetails.toJSON(message.inputTokenDetails);
    }
    if (message.outputTokenDetails !== undefined) {
      obj.outputTokenDetails = OutputTokenDetails.toJSON(message.outputTokenDetails);
    }
    return obj;
  },

  create(base?: DeepPartial<TokensUsageStats>): TokensUsageStats {
    return TokensUsageStats.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TokensUsageStats>): TokensUsageStats {
    const message = createBaseTokensUsageStats();
    message.inputTokens = object.inputTokens ?? 0;
    message.outputTokens = object.outputTokens ?? 0;
    message.totalTokens = object.totalTokens ?? 0;
    message.inputTokenDetails = (object.inputTokenDetails !== undefined && object.inputTokenDetails !== null)
      ? InputTokenDetails.fromPartial(object.inputTokenDetails)
      : undefined;
    message.outputTokenDetails = (object.outputTokenDetails !== undefined && object.outputTokenDetails !== null)
      ? OutputTokenDetails.fromPartial(object.outputTokenDetails)
      : undefined;
    return message;
  },
};

function createBaseInputTokenDetails(): InputTokenDetails {
  return { audio: 0, cacheRead: 0, cacheCreation: 0 };
}

export const InputTokenDetails: MessageFns<InputTokenDetails> = {
  encode(message: InputTokenDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.audio !== 0) {
      writer.uint32(8).int32(message.audio);
    }
    if (message.cacheRead !== 0) {
      writer.uint32(16).int32(message.cacheRead);
    }
    if (message.cacheCreation !== 0) {
      writer.uint32(24).int32(message.cacheCreation);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InputTokenDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInputTokenDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.audio = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.cacheRead = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.cacheCreation = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InputTokenDetails {
    return {
      audio: isSet(object.audio) ? globalThis.Number(object.audio) : 0,
      cacheRead: isSet(object.cacheRead)
        ? globalThis.Number(object.cacheRead)
        : isSet(object.cache_read)
        ? globalThis.Number(object.cache_read)
        : 0,
      cacheCreation: isSet(object.cacheCreation)
        ? globalThis.Number(object.cacheCreation)
        : isSet(object.cache_creation)
        ? globalThis.Number(object.cache_creation)
        : 0,
    };
  },

  toJSON(message: InputTokenDetails): unknown {
    const obj: any = {};
    if (message.audio !== 0) {
      obj.audio = Math.round(message.audio);
    }
    if (message.cacheRead !== 0) {
      obj.cacheRead = Math.round(message.cacheRead);
    }
    if (message.cacheCreation !== 0) {
      obj.cacheCreation = Math.round(message.cacheCreation);
    }
    return obj;
  },

  create(base?: DeepPartial<InputTokenDetails>): InputTokenDetails {
    return InputTokenDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<InputTokenDetails>): InputTokenDetails {
    const message = createBaseInputTokenDetails();
    message.audio = object.audio ?? 0;
    message.cacheRead = object.cacheRead ?? 0;
    message.cacheCreation = object.cacheCreation ?? 0;
    return message;
  },
};

function createBaseOutputTokenDetails(): OutputTokenDetails {
  return { audio: 0, reasoning: 0 };
}

export const OutputTokenDetails: MessageFns<OutputTokenDetails> = {
  encode(message: OutputTokenDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.audio !== 0) {
      writer.uint32(8).int32(message.audio);
    }
    if (message.reasoning !== 0) {
      writer.uint32(16).int32(message.reasoning);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OutputTokenDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOutputTokenDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.audio = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.reasoning = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OutputTokenDetails {
    return {
      audio: isSet(object.audio) ? globalThis.Number(object.audio) : 0,
      reasoning: isSet(object.reasoning) ? globalThis.Number(object.reasoning) : 0,
    };
  },

  toJSON(message: OutputTokenDetails): unknown {
    const obj: any = {};
    if (message.audio !== 0) {
      obj.audio = Math.round(message.audio);
    }
    if (message.reasoning !== 0) {
      obj.reasoning = Math.round(message.reasoning);
    }
    return obj;
  },

  create(base?: DeepPartial<OutputTokenDetails>): OutputTokenDetails {
    return OutputTokenDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<OutputTokenDetails>): OutputTokenDetails {
    const message = createBaseOutputTokenDetails();
    message.audio = object.audio ?? 0;
    message.reasoning = object.reasoning ?? 0;
    return message;
  },
};

function createBaseUserMention(): UserMention {
  return { userId: "", companyId: 0, createdAt: undefined, updatedAt: undefined, target: undefined };
}

export const UserMention: MessageFns<UserMention> = {
  encode(message: UserMention, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(26).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(34).fork()).join();
    }
    switch (message.target?.$case) {
      case "commentId":
        writer.uint32(802).string(message.target.value);
        break;
      case "documentId":
        writer.uint32(810).string(message.target.value);
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserMention {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserMention();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.target = { $case: "commentId", value: reader.string() };
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.target = { $case: "documentId", value: reader.string() };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserMention {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      target: isSet(object.commentId)
        ? { $case: "commentId", value: globalThis.String(object.commentId) }
        : isSet(object.comment_id)
        ? { $case: "commentId", value: globalThis.String(object.comment_id) }
        : isSet(object.documentId)
        ? { $case: "documentId", value: globalThis.String(object.documentId) }
        : isSet(object.document_id)
        ? { $case: "documentId", value: globalThis.String(object.document_id) }
        : undefined,
    };
  },

  toJSON(message: UserMention): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.target?.$case === "commentId") {
      obj.commentId = message.target.value;
    } else if (message.target?.$case === "documentId") {
      obj.documentId = message.target.value;
    }
    return obj;
  },

  create(base?: DeepPartial<UserMention>): UserMention {
    return UserMention.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UserMention>): UserMention {
    const message = createBaseUserMention();
    message.userId = object.userId ?? "";
    message.companyId = object.companyId ?? 0;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    switch (object.target?.$case) {
      case "commentId": {
        if (object.target?.value !== undefined && object.target?.value !== null) {
          message.target = { $case: "commentId", value: object.target.value };
        }
        break;
      }
      case "documentId": {
        if (object.target?.value !== undefined && object.target?.value !== null) {
          message.target = { $case: "documentId", value: object.target.value };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseChunksInfo(): ChunksInfo {
  return { totalChunks: 0 };
}

export const ChunksInfo: MessageFns<ChunksInfo> = {
  encode(message: ChunksInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.totalChunks !== 0) {
      writer.uint32(8).int32(message.totalChunks);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChunksInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChunksInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.totalChunks = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChunksInfo {
    return {
      totalChunks: isSet(object.totalChunks)
        ? globalThis.Number(object.totalChunks)
        : isSet(object.total_chunks)
        ? globalThis.Number(object.total_chunks)
        : 0,
    };
  },

  toJSON(message: ChunksInfo): unknown {
    const obj: any = {};
    if (message.totalChunks !== 0) {
      obj.totalChunks = Math.round(message.totalChunks);
    }
    return obj;
  },

  create(base?: DeepPartial<ChunksInfo>): ChunksInfo {
    return ChunksInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ChunksInfo>): ChunksInfo {
    const message = createBaseChunksInfo();
    message.totalChunks = object.totalChunks ?? 0;
    return message;
  },
};

function createBaseErrorInfo(): ErrorInfo {
  return { message: "", ts: undefined };
}

export const ErrorInfo: MessageFns<ErrorInfo> = {
  encode(message: ErrorInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    if (message.ts !== undefined) {
      Timestamp.encode(toTimestamp(message.ts), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ErrorInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseErrorInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ts = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ErrorInfo {
    return {
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      ts: isSet(object.ts) ? fromJsonTimestamp(object.ts) : undefined,
    };
  },

  toJSON(message: ErrorInfo): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.ts !== undefined) {
      obj.ts = message.ts.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<ErrorInfo>): ErrorInfo {
    return ErrorInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ErrorInfo>): ErrorInfo {
    const message = createBaseErrorInfo();
    message.message = object.message ?? "";
    message.ts = object.ts ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
